export default "__VITE_ASSET__CxZmv6yy__"